import { v4 as uuid } from "uuid";

export const PRODUCT = [
  {
    id: uuid(),
    title: "ПАЛАТКА NATUREHIKE CLOUD UP 2 210T",
    img: "cloudup2-green-210T.jpg",
    desc: "2-х местная двухслойная палатка 150*275*110",
    category: "tent",
    price: 690,
    shortly:
      "Ультралегкая двухместная палатка для пеших, водных и вело-походов. В просторный тамбур можно разместить пару рюкзаков внушительных размеров.",
    column: [
      "Каркас изготовлен из очень прочного, но гибкого легированного алюминия марки 7001",
      "Комната 210*125 см",
      "Высота: 100 см",
      "Внешний тент выполнен из тонкого и легкого полиэстера 210T с плетением RipStop и PU пропиткой",
      "Ткань устойчива к ультрафиолету, не растягивается при намокании",
      "В комплект входит дополнительный пол (футпринт), защищающий дно палатки от повреждений и загрязнения",
      "Вес: 1,83 кг",
      "Палатка комплектуется фирменными колышками Y-образного сечения. Вес одного всего 9 грамм. На каждом из них предусмотрены выемки для фиксации оттяжки и петелька из шнура для извлечения из грунта",
      "Водостойкость навес (мм в. ст.): >3000",
      "Водостойкость дна (мм в. ст.): >3000",
      "Чехол для хранения и транспортировки",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА NATUREHIKE CLOUD UP 3 210T",
    img: "CloudUp3-orange-210T.jpg",
    desc: "3-х местная двухслойная палатка 180*300*110",
    category: "tent",
    price: 810,
    shortly:
      "Ультралегкая двухместная палатка для пеших, водных и вело-походов. В просторный тамбур можно разместить пару рюкзаков внушительных размеров.",
    column: [
      "Каркас изготовлен из очень прочного, но гибкого легированного алюминия марки 7001",
      "Комната 215*180 см",
      "Высота: 100 см",
      "Внешний тент выполнен из тонкого и легкого полиэстера 210T с плетением RipStop и PU пропиткой",
      "Ткань устойчива к ультрафиолету, не растягивается при намокании",
      "В комплект входит дополнительный пол (футпринт), защищающий дно палатки от повреждений и загрязнения",
      "Вес: 2,4 кг",
      "Палатка комплектуется фирменными колышками Y-образного сечения. Вес одного всего 9 грамм. На каждом из них предусмотрены выемки для фиксации оттяжки и петелька из шнура для извлечения из грунта",
      "Водостойкость навес (мм в. ст.): >3000",
      "Водостойкость дна (мм в. ст.): >3000",
      "Чехол для хранения и транспортировки",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА NATUREHIKE CLOUD UP 2 20D SNOW SKIRT",
    img: "naturehike_show_skirt.jpg",
    desc: "2-х местная двухслойная палатка 150*275*110",
    category: "tent",
    price: 799,
    shortly:
      "Ультралёгкая туристическая палатка с юбкой, рассчитанная на комфортное размещение 2 человек.",
    column: [
      "Тент изготовлен из силиконизированного нейлона 20D",
      "Комната 210*125 см",
      "Высота: 110 см",
      "Юбка по краю тента защитит от снега, дождя и сильного ветра",
      "Основная часть внутренней палатки, выполненная из сетки B3, защищает от насекомых и обеспечивает циркуляцию воздуха",
      "Ткань устойчива к ультрафиолету, не растягивается при намокании",
      "В комплект входит дополнительный пол (футпринт), защищающий дно палатки от повреждений и загрязнения",
      "Вес: 1,7 кг",
      "Палатка комплектуется фирменными колышками Y-образного сечения. Вес одного всего 9 грамм. На каждом из них предусмотрены выемки для фиксации оттяжки и петелька из шнура для извлечения из грунта",
      "Водостойкость навес (мм в. ст.): >4000",
      "Водостойкость дна (мм в. ст.): >4000",
      "Чехол для хранения и транспортировки",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА NATUREHIKE CLOUD UP 3 20D SNOW SKIRT",
    img: "20DGREYWITHSKIRT.webp",
    desc: "3-х местная двухслойная палатка 180*300*110",
    category: "tent",
    price: 891,
    shortly: "Ультралёгкая туристическая палатка с юбкой.",
    column: [
      "Тент изготовлен из силиконизированного нейлона 20D",
      "Комната 215*180 см",
      "Высота: 110 см",
      "Юбка по краю тента защитит от снега, дождя и сильного ветра",
      "Основная часть внутренней палатки, выполненная из сетки B3, защищает от насекомых и обеспечивает циркуляцию воздуха",
      "Ткань устойчива к ультрафиолету, не растягивается при намокании",
      "В комплект входит дополнительный пол (футпринт), защищающий дно палатки от повреждений и загрязнения",
      "Вес: 2,05 кг",
      "Палатка комплектуется фирменными колышками Y-образного сечения. Вес одного всего 9 грамм. На каждом из них предусмотрены выемки для фиксации оттяжки и петелька из шнура для извлечения из грунта",
      "Водостойкость навес (мм в. ст.): > 4000",
      "Водостойкость дна (мм в. ст.): > 4000",
      "Чехол для хранения и транспортировки",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА NATUREHIKE CLOUD UP UP 1 210T ",
    img: "clouduporange210T.jpg",
    desc: "1-местная двухслойная палатка  120*295*110",
    category: "tent",
    price: 559,
    shortly: "Ультралёгкая туристическая палатка с юбкой.",
    column: [
      "Внешний тент выполнен из тонкого и легкого полиэстера 210T с плетением RipStop и PU пропиткой",
      "Водостойкость навес (мм в. ст.): > 3000",
      "Водостойкость дна (мм в. ст.): > 3000",
      "Размер спального места составляет 230 x 910 x 100 см",
      "Вес: 1,57 кг.",
      "На потолке внутри имеется крючок для подвески фонарика. На стенках удобные кармашки из сетки для различных мелочей, которые будут всегда под рукой",
      "Все швы качественно проклеены специальной лентой препятствуют проникновению влаги через нитки",
      "Каркас изготовлен из очень прочного, но гибкого легированного алюминия марки 7001",
      "Палатка комплектуется фирменными колышками Y-образного сечения. Вес одного всего 9 грамм",
      "Дуги и колышки покрыты электрохимическим анодированием, что не только уберегает их от коррозии",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА QUECHUA MH-100",
    img: "DECATHLON2ух.jpg",
    desc: "2-х местная двухслойная палатка 130*210*107",
    category: "tent",
    price: 249,
    shortly:
      "Простая и легкая в установке, эта эко-палатка предназначена для ваших лагерей на 2 человек. Экологичная и недорогая палатка. Благодаря отдельно стоящей куполообразной конструкции вы можете перемещать палатку, чтобы выбрать наиболее подходящее для вас место для кемпинга.",
    column: [
      "Комната: 130*210 см",
      "Рост: 107см",
      "Размер корпуса: 58*16*16 см / 12 л",
      "Вес: 2.6 кг ",
      "Ткань с защитой SPF 30: Пропускает дневной свет, фильтрует УФ-лучи",
      "Водостойкость навес (мм в. ст.): 2000",
      "Водостойкость дна (мм в. ст.): 2400",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА QUECHUA MH-100",
    img: "DECATHLON2ух.jpg",
    desc: "3-х местная двухслойная палатка 130*210*107",
    category: "tent",
    price: 299,
    shortly:
      "Простая и легкая в установке, эта эко-палатка предназначена для ваших лагерей на 3 человека. Благодаря отдельно стоящей куполообразной конструкции вы можете перемещать палатку, чтобы выбрать наиболее подходящее для вас место для кемпинга.",
    column: [
      "Задняя вентиляция",
      "Выдерживает ветер силой 5 баллов (40 км/ч)",
      "Комната 195*210 см",
      "Высота: 120 см",
      "Размер корпуса: 59*17*17 см / 13 л",
      "Вес: 3.4 кг",
      "Ткань с защитой SPF 30: Прропускает дневной свет, фильтрует УФ-лучи",
      "Водостойкость навес (мм в. ст.): 2000",
      "Водостойкость дна (мм в. ст.): 2400",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА QUECHUA MH-100 FRESH&BLACK",
    img: "camping-tent-mh100-2-person-fresh-and-black.jpg",
    desc: "2-х местная двухслойная палатка 130*210*106",
    category: "tent",
    price: 330,
    shortly:
      "Двухместную палатку Fresh&Black, которую легко и просто установить. Благодаря отдельно стоящей купольной конструкции его можно переместить в лучшее место после установки.",
    column: [
      "Задняя вентиляция",
      "Выдерживает ветер силой 5 баллов (40 км/ч)",
      "Комната 130*210 см",
      "Высота: 106 см",
      "Размер сумки: 58*15*14 см / 10 л",
      "Вес: 3 кг",
      "Ткань с защитой SPF 30: Прропускает дневной свет, фильтрует УФ-лучи",
      "Водостойкость навес (мм в. ст.): 2000",
      "Водостойкость дна (мм в. ст.): 2400",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА BTRACE VANG 3",
    img: "BTRACE-VANG3.png",
    desc: "3-х местная двухслойная палатка с двумя входами 340*220*120",
    category: "tent",
    price: 687,
    shortly:
      "Двухслойная палатка с двумя входами.Вход спального отделения продублирован москитной сеткой.Увеличенный тамбур, два вентиляционных клапана, все швы проклеены. Идеальна для туристических походов в весеннее, летнее и осеннее время.",
    column: [
      "Производитель: BTRACE",
      "Материал каркаса: Фибергласс 8,5 мм",
      "Материал тента: 100% полиэстер 75D/190T PU W/R",
      "Водостойкость тента (мм в. ст): 4000",
      " Материал внутренней палатки: 100% полиэстер",
      "Цвет внутренней палатки: Желтый",
      "Вес (г): 3400",
      "Количество слоев: 2",
      "Устойчивость к ультрафиолетовому излучению:Да",
      "Количество мест: 3",
      "Количество входов: 2",
      "Комплектация: Колышки, оттяжки, инструкция",
      "Размер в упаковке (см): 63*16*14",
      "Высота (см): 120",
      "Наружний габарит (см): 340*220",
      "Тамбур (см): 2*80",
      "Упаковка: Тканевая сумкa",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА BTRACE TRAVEL 2",
    img: "BTRACE_TRAVEL2.jpg",
    desc: "2-х местная двухслойная палатка с двумя входами 250*220*120",
    category: "tent",
    price: 841,
    shortly:
      "Двухслойная палатка с двумя входами. Внешний тент палатки устойчив к ультрафиолетовому излучению .Внешний тент имеет пропитку, задерживающую распространение огня. Два вентиляционных клапана. Светоотражающие оттяжки и элементы на вентиляции. Все швы проклеены. Идеальна для туристических походов в весеннее, летнее и осеннее время.",
    column: [
      "Производитель: BTRACE",
      "Материал каркаса: Durapol 8,5 мм",
      "Материал тента: 100% полиэстер 75D/190Т RipStop",
      "Водостойкость тента (мм в. ст): 6000",
      "Материал дна: 100% полиэстер 75D/190Т",
      "Водостойкость дна (мм в. ст.): 8000",
      " Материал внутренней палатки: 100% полиэстер",
      "Цвет внутренней палатки: Желтый",
      "Вес (г): 3750",
      "Количество слоев: 2",
      "Устойчивость к ультрафиолетовому излучению:Да",
      "Количество мест: 2",
      "Количество входов: 2",
      "Комплектация: Колышки, оттяжки, инструкция",
      "Размер в упаковке (см): 57*17*14,5",
      "Высота (см): 120",
      "Наружний габарит (см): 250*220",
      "Тамбур (см): 2*50",
      "Упаковка:Тканевая сумка",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА BTRACE TRAVEL 3",
    img: "BTRACE_TRAVEL3.jpg",
    desc: "3-х местная двухслойная палатка с двумя входами 320*220*120",
    category: "tent",
    price: 939,
    shortly:
      "Двухслойная палатка с двумя входами. Внешний тент палатки устойчив к ультрафиолетовому излучению. Внешний тент имеет пропитку, задерживающую распространение огня. Два вентиляционных клапана. Светоотражающие оттяжки и элементы на вентиляции. Все швы проклеены. Идеальна для туристических походов в весеннее, летнее и осеннее время.",
    column: [
      "Производитель: BTRACE",
      "Материал каркаса: Durapol 8,5 мм",
      "Материал тента: 100% полиэстер 75D/190Т RipStop",
      "Водостойкость тента (мм в. ст): 6000",
      "Материал дна: 100% полиэстер 75D/190Т",
      "Водостойкость дна (мм в. ст.): 8000",
      "Материал внутренней палатки: 100% полиэстер",
      "Цвет внутренней палатки: Желтый",
      "Вес (г): 3900",
      "Количество слоев: 2",
      "Устойчивость к ультрафиолетовому излучению: Да",
      "Количество мест: 3",
      "Количество входов: 2",
      "Комплектация: Колышки, оттяжки, инструкция",
      "Размер в упаковке (см): 57*17*14,5",
      "Высота (см):120",
      "Наружний габарит (см):320*220",
      "Тамбур (см): 2*70",
      "Упаковка: Тканевая сумка",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА BTRACE CHALLENGE 2",
    img: "BTRACE_CHALLENGE2.webp",
    desc: "3-х местная двухслойная палатка с двумя входами 300*210*120",
    category: "tent",
    price: 1021,
    shortly:
      "Двухслойная палатка с двумя входами. Внешний тент палатки устойчив к ультрафиолетовому излучению. Внешний тент имеет пропитку, задерживающую распространение огня. Большой вместительный тамбур. Два вентиляционных клапана. Светоотражающие оттяжки и элементы на вентиляции. Все швы проклеены. Идеальна для туристических походов в весеннее, летнее и осеннее время.",
    column: [
      "Производитель: BTRACE",
      "Материал каркаса: Durapol 8,5 мм",
      "Материал тента: 100% полиэстер 75D/190Т RipStop",
      "Водостойкость тента (мм в. ст): 6000",
      "Материал дна: 100% полиэстер 75D/190Т",
      "Водостойкость дна (мм в. ст.): 8000",
      "Материал внутренней палатки: 100% полиэстер",
      "Цвет внутренней палатки: Желтый",
      "Вес (г): 4000",
      "Количество слоев: 2",
      "Устойчивость к ультрафиолетовому излучению: Да",
      "Количество мест: 2",
      "Количество входов: 2",
      "Комплектация: Колышки, оттяжки, инструкция",
      "Размер в упаковке (см): 57*17,5*15,5",
      "Высота (см): 120",
      "Наружний габарит (см): 300*210",
      "Тамбур (см): 1*100, 1*50",
      "Упаковка: Тканевая сумка",
    ],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК",
    img: "sleeping_bag_green.jpg",
    desc: "195*60см от +15 до 0",
    category: "sleeping bag",
    price: 96,
    column: ["Вес: 960гр", "Размер внешний: 35*26см"],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК QUECHUA ARPENAZ",
    img: "sleepingBad20.jpg",
    desc: "190*72см от +20 до +15",
    category: "sleeping bag",
    price: 114,
    shortly:
      "Этот эко-спальный мешок предназначен для пользователей, которые хотят комфортно спать при температуре до 20°C во время кемпинга.",
    column: [
      "Вес: 755гр",
      "Размер: 190*72 см | Молния от шеи",
      "Объем: 9 л",
      "Наполнитель: 100% полиэстер",
    ],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК QUECHUA ARPENAZ",
    img: "sleepingBag+15.jpg",
    desc: "190*72см от +15 до +8",
    category: "sleeping bag",
    price: 159,
    shortly:
      "Этот эко-спальный мешок предназначен для пользователей, которые хотят комфортно спать при температуре до 15°C во время кемпинга.",
    column: [
      "Вес: 755гр",
      "Размер: 190*72 см | Молния от шеи",
      "Объем: 9 л",
      "Наполнитель: 100% полиэстер",
    ],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК CAMPSOR",
    img: "sleeping_bag_red.jpg",
    desc: "210*66см от +10 до 0",
    category: "sleeping bag",
    price: 160,
    column: ["Вес: 1300гр", "Размер внешний: 33*24см"],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК DESERT FOX",
    img: "desert-fox-sleeping.webp",
    desc: "180+20*70см от +15 до -5",
    category: "sleeping bag",
    price: 170,
    column: ["Вес: 1370гр", "Материал: 100% полиэстерн, полиэфрное волокно"],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК ДЕМИСЕЗОННЫЙ",
    img: "sleeping_bag_blie.jpg",
    desc: "195*60см от +10",
    category: "sleeping bag",
    price: 125,
    column: [
      "Вес: 1060гр",
      "Размер внешний: 40*25см",
      "Материал: полиэстерн, СИНТЕПОН",
    ],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК BTRACE MEGA ЛЕВЫЙ",
    img: "sleeping_bag_BTRACE_MEGA.webp",
    desc: "Утеплитель 195(+35)*100 от 0 до -21",
    category: "sleeping bag",
    price: 659,
    shortly:
      "Утеплитель.В качестве утеплителя используется lzoShell 40.Разнонаправленные супертонкие полые волокна утеплителя lzoShell 4D создают множество микрополостей, где удерживается теплый воздух. Волокна утеплителя соединены между собой синтетической смолой, что делает утеплитель lzoShell 4D более воздушным, долговечным и неприхотливым в эксплуатации. Низкий коэффициент теплопроводности, высокие гидрофобные и потребительские качества делают утеплитель lzoShell 4D одним из лучших утеплителей для спальных мешков. Внешний материал верхней части спальника Polyester 190Т с плетением Rip Stop, специальная паропроницаемая ткань, которая позволяет выводить пар не конденсируя влагу внутри спальника. Внешний материал нижней части спальника Polyester 190Т с плетением Diamond Rip Stop со специальным водонепроницаемым покрытием PU 250 мм водяного столба, надёжно защищает спальник от повреждения и влаги. Внутренний материал Фланель 100% Cotton - шелковистая, мягкая и комфортная ткань.",
    column: [
      "Производитель: BTRACE",
      "Температура экстрима: -21",
      "Температура комфорта: 0",
      "Вес (г):3210",
      "Материал внешний: Полиэстер 190Т RipStop/Полиэстер 190Т Diamond RipStop WR",
      "Внутренний материал: 100% хлопок (фланель)",
      "Утеплитель: Izoshell 4D 2*150 г/м2",
      "Размер в упаковке (см): 56*25*25",
      "Размер (см): (195+35)х100",
      "Упаковка: Тканевый мешок",
    ],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК BTRACE ZERO L SIZE ПРАВЫЙ",
    img: "BTRACE_ZERO_L.png",
    desc: "Супер лёгкий 220*90(55) от +15 до 0 ",
    category: "sleeping bag",
    price: 449,
    shortly:
      "Новинка сезона 2021 - супер лёгкий спальный мешок-кокон BTrace Zero. Он идеально подойдёт для небольших путешествий в теплую погоду. Занимая совсем мало места, этот спальный мешок позволит с комфортом переночевать в походных условиях. Как и другие спальные мешки-коконы этой серии, BTrace Zero имеет возможность состёгиваться. Также можно выбрать один из 2х размеров, чтоб сэкономить ещё места и веса, если рост позволяет пользоваться спальным мешком меньшего размера.",
    column: [
      "Производитель:BTRACE",
      "Температура экстрима:0",
      "Температура комфорта:+5",
      "Вес (г):800",
      "Материал внешний: Полиэстер 20D 380Т Nylon RipStop WR",
      "Внутренний материал: 100% полиэстер 210T Soft Nylon",
      "Утеплитель: Izoshell Pro 2*80 г/м2",
      "Размер в упаковке (см): 52*25*25",
      "Размер (см): 220*90(55)",
      "Упаковка: Тканевый мешок",
    ],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК BTRACE ZERO S SIZE ПРАВЫЙ",
    img: "BTRACE_ZERO_S.png",
    desc: "Супер лёгкий 190*80(50) от +15 до 0 ",
    category: "sleeping bag",
    price: 399,
    shortly:
      "Новинка сезона 2021 - супер лёгкий спальный мешок-кокон BTrace Zero. Он идеально подойдёт для небольших путешествий в теплую погоду. Занимая совсем мало места, этот спальный мешок позволит с комфортом переночевать в походных условиях. Как и другие спальные мешки-коконы этой серии, BTrace Zero имеет возможность состёгиваться. Также можно выбрать один из 2х размеров, чтоб сэкономить ещё места и веса, если рост позволяет пользоваться спальным мешком меньшего размера.",
    column: [
      "Производитель:BTRACE",
      "Температура экстрима:0",
      "Температура комфорта:+15",
      "Вес (г):600",
      "Материал внешний: Полиэстер 20D 380Т Nylon RipStop WR",
      "Внутренний материал: 100% полиэстер 210T Soft Nylon",
      "Утеплитель: Izoshell Pro 2*80 г/м2",
      "Размер в упаковке (см): 52х25х25",
      "Размер (см): 190*80(50)",
      "Упаковка: Тканевый мешок",
    ],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ CAMPSOR",
    img: "Сampsor_blue.jpg",
    desc: " 75+10L В комплекте дождевик. Жесткая, регулируемая спинкаю",
    category: "backpack",
    price: 348,
    column: ["Объем: 75+10 л", "Цвет: Синий", "Материал: Нейлон", "Вес:1,55кг"],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ",
    img: "Cakard_black_backpack.jpg",
    desc: "95+10L Сakard ",
    category: "backpack",
    price: 210,
    column: ["Объем: 95+10 л"],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ",
    img: "THENORTHFACE_red.jpg",
    desc: "55L THE NORTH FACE(REPLICA) ",
    category: "backpack",
    price: 195,
    shortly:
      "Треккинговый рюкзак среднего объема TNF Terra 55 отлично подходит для путешествий. Лямкам рюкзак можно настроить под свои параметры.",
    column: ["Вес: 1.8 кг", "Материал: Нейлон"],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ",
    img: "backpack_grey1.jpg",
    desc: "80L THE NORTH FACE(REPLICA) ",
    category: "backpack",
    price: 260,
    shortly: "Невероятно вместительная модель с множеством полезных функций.",
    column: ["Обьем: 80 л", "Анатомическая спинка", "Компрессионные ремни"],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ",
    img: "THENORTHFACE_blue.jpg",
    desc: "50L THE NORTH FACE(REPLICA) ",
    category: "backpack",
    price: 172,
    shortly:
      "Легкий, надежный и полностью регулируемый рюкзак для многодневных выходов и путешествий налегке. Рюкзак NorthFace обладая объемом 50л, подойдет для скалолазания, походов и путешествий.",
    column: ["Объем: 50л", "Конструкция: Мягкий (без элементов жесткости)"],
  },
  {
    id: uuid(),
    title: "РЮКЗАК (РЕПЛИКА) 60Л",
    img: "backpackTheNord.jpg",
    desc: "THE NORTH FACE 601",
    category: "backpack",
    price: 230,
    shortly:
      "Предназначен для походов средней протяженности и изготовлен из прочного и износостойкого материала.",
    column: [
      "Размеры: 70*39*26",
      "Объем: 60Л",
      "Изготовлен из прочной водоотталкивающей и устойчивой к царапинам ткани ч20д",
      "E-VA™ плечевые ремни",
      "Фиксация на груди и на поясе отстегивающаяся жесткая спинка aircomfort с поясными лямками",
      "Есть отдел для ноутбука и отверстие для наушников",
      "Дождевик в комплекте",
    ],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ DEUTER FUTURA PRO",
    img: "backpack_65.jpg",
    desc: "65L (REPLICA). В комплекте дождевик.",
    category: "backpack",
    price: 310,
    shortly:
      "Легкий, надежный и полностью регулируемый рюкзак для многодневных выходов и путешествий налегке.",
    column: ["Объем: 65л", "Вес:1,7кг"],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ QUECHUA NH-100",
    img: "backpack30L.jpg",
    desc: "30L экологичный рюкзак, износостойкий ",
    category: "backpack",
    price: 125,
    shortly:
      "Спинка и лямки с накладками, 2 опорные петли на ремнях, нагрудная лямка. Боковые компрессионные ремни для оптимального распределения нагрузки.",
    column: ["Объем: 30л", "Вес:0,62кг", "Размеры:50*26*20"],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ FORCLAZ",
    img: "quechuaforclaz40+10.jpg",
    desc: "40+10L Регулируемая спика 140/150/160/170/см",
    category: "backpack",
    price: 319,
    shortly:
      "Износостойкие компоненты, усиленное днище. Спинка и лямки с накладками, 2 опорные петли на ремнях, нагрудная лямка. Боковые компрессионные ремни для оптимального распределения нагрузки.",
    column: ["Объем: 40+10л", "Вес:1,4кг", "Размеры:64*26*30"],
  },
  {
    id: uuid(),
    title: "РЮКЗАК QUECHUA 10Л",
    img: "backpack10.webp",
    desc: "Мягкая спинка и лямки",
    category: "backpack",
    price: 39,
    shortly:
      "Рюкзак объемом 10 литров разработан таким образом, чтобы вы могли безопасно переносить предметы первой необходимости на всех тропах с пологими склонами.",
    column: ["Объем: 10л", "Вес: 0,145кг", "Размеры:39*21*12"],
  },
  {
    id: uuid(),
    title: "РЮКЗАК 17Л QUECHUA",
    img: "backpackBlack17L.jpg",
    desc: "NH ESCAPE 100",
    category: "backpack",
    price: 67,
    shortly:
      "Экологичный 17-литровый рюкзак NH Escape 100 для случайных прогулок и перемещений",
    column: [
      "Регулируемые спинка и лямки из пеноматериала",
      "1 отделение с 1 перегородкой для ПК 15'",
      "Устойчивые к истиранию материалы ",
      "Дно: усиленный пеноматериал",
      "Объем: 17 л",
      "Вес: 250 г",
      "Размеры: 40 x 26 x 13 см",
      "Подкладка: 100.0% Полиэтилентерефталат",
      "Основной материал: 100.0% Полиэтилентерефталат",
      "Внимание: материалы не водонепроницаемые. Чехол не прилагается.",
    ],
  },
  {
    id: uuid(),
    title: "АЛЬПИНИСТСКИЙ РЮКЗАК 20Л",
    img: "backpackAlpin.jpg",
    desc: "CUFF SIMOND",
    category: "backpack",
    price: 110,
    shortly:
      "Минималистичный и компактный объемом 20 литров, это идеальный вариант для скалолазов, которым нужен очень легкий рюкзак для дневных восхождений.",
    column: [
      "Сверхлегкий рюкзак: 265 г.",
      "Ременные петли для переноски экипировки. Складывается во внутренний карман",
      "Система открывания Easy Access: залог легкости и скорости",
      "Высота: 50 см. Ширина: 24 см. Глубина: 18 см.",
      "- Сверхлегкие лямки с сетчатым покрытием. - Нагрудный ремень регулируется по ширине и высоте для того, чтобы лямки не сползали с плеч",
      "Петли для фиксации снаряжения (карабинов, оттяжек и т. д.). - Внутреннее отделение для питьевой системы с 2 подвесными застежками.",
      "Внешний карман на молнии 28 x 16 см для аксессуаров (телефона, карты, GPS)",
    ],
  },
  {
    id: uuid(),
    title: "СКЛАДНОЙ (ШТУРМОВОЙ) РЮКЗАК 10 Л",
    img: "backpackForclaz.jpg",
    desc: "FORCIAZ TRAVEL",
    category: "backpack",
    price: 27,
    shortly:
      "Этот компактный дополнительный рюкзак, чтобы облегчить Вам походы по всему миру с рюкзаком.",
    column: [
      "Может вместить до 10 л.",
      "В пустом виде весит 45 г.",
      "Усиленные лямки",
      "Рюкзак складывается в себя для хранения, чтобы занимать как можно меньше места",
      "1 большое основное отделение + 1 карман на молнии",
    ],
  },
  {
    id: uuid(),
    title: "ТУРИСТИЧЕСКИЙ РЮКЗАК",
    img: "backpackNaturehike60.jpg",
    desc: "NATUREHIKE ROCK 60+51",
    category: "backpack",
    price: 395,
    shortly:
      "Сверхлегкий туристический рюкзак объемом 60 литров с жесткой рамой весом всего 1,16 кг.",
    column: [
      "Выполнен из нейлона DYNEEMA 420D, который превосходит по прочности сталь в 20 раз",
      "Вместительное основное отделение",
      "Система подвески с алюминиевым каркасом для лучшей воздухопроницаемости и снятия нагрузки с плеч",
      "Регулируемая грудная стяжка",
      "S-образные регулируемые плечевые лямки со съемным карманом",
      "Широкий поясной ремень с карманами для мелочей или еды",
      "Отделение для питьевой системы",
      "Выход для трубки питьевой системы на лямке",
      "Боковые сетчатые карманы",
      "Боковые стяжки",
      "Объемный карман спереди",
      "В комплекте чехол от дождя (в отсеке на дне)",
      "Имеет большой объем и грузоподъемность 14 кг.",
      "Модель 2022г.",
    ],
  },
  {
    id: uuid(),
    title: "ТУРИСТИЧЕСКИЙ РЮКЗАК 5OЛ",
    img: "backpack10.jpg",
    desc: "FORCIAZ",
    category: "backpack",
    price: 254,
    shortly:
      "Рюкзак для всех Ваших первых приключений на воздухе, будь то горный поход или путешествие на край света",
    column: [
      "Ремешок из пеноматериала. Нагруд. ремень. Оттяжки. Петли д/рук. Регулируемая спинка.",
      "Рюкзак весит примерно 1,4 кг.",
      "Карманы: 3 внеш., 1 внут., 1 поясн. Доступ в осн.отдел. и отсекам",
      "Держатели палок",
      "Основная. ткань — П600, с пропиткой внутри для усиления прочности",
      "Объем: 50 л",
      "Вес: 1,4 кг",
      "Размеры: 62 x 32 x 24 см",
      "Любые пряжки рюкзака можно заменить в качестве поломки",
    ],
  },
  {
    id: uuid(),
    title: "ТУРИСТИЧЕСКИЙ РЮКЗАК 65Л",
    img: "backpack11.jpg",
    desc: "NATUREHIKE HIKING 65",
    category: "backpack",
    price: 570,
    shortly:
      "Предназначен для походов средней протяженности и изготовлен из прочного и износостойкого материала.",
    column: [
      "Размеры: 78*33.5*25",
      "Вес: 2кг",
      "Материал: нейлон",
      "Система подвески имеет жесткий каркас, состоящий из двух алюминиевых пластин, что обеспечивает хорошую вентиляцию спины и снимает нагрузку с плеч",
      "Вместительное основное отделение",
      "Система подвески с алюминиевым каркасом для лучшей воздухопроницаемости и снятия нагрузки с плеч",
      "Клапан с регулируемым по высоте положением",
      "Широкий и мягкий поясной ремень с карманом для мелочей или еды",
      "Регулируемая грудная стяжка со спасательным свистком",
      "Регулируемые плечевые лямки",
      "Отделение для питьевой системы",
      "Резинки для фиксации трубки питьевой системы",
      "Боковые карманы",
      "Боковые стяжки",
      "Пластиковые полукольца для крепления снаряжения спереди",
      "Крепления для треккинговых палок",
      "Карман спереди для дождевика или веревки",
      "Внутренний сетчатый карман",
      "В комплекте чехол от дождя (в отсеке на дне)",
    ],
  },
  {
    id: uuid(),
    title: "ТУРИСТИЧЕСКИЙ РЮКЗАК 55Л",
    img: "backpack12.jpg",
    desc: "NATUREHIKE HIKING 55",
    category: "backpack",
    price: 529,
    shortly:
      "Предназначен для походов средней протяженности и изготовлен из прочного и износостойкого материала.",
    column: [
      "Размеры: 78*32*23",
      "Вес: 1.9кг",
      "Материал: нейлон",
      "Система подвески имеет жесткий каркас, состоящий из двух алюминиевых пластин, что обеспечивает хорошую вентиляцию спины и снимает нагрузку с плеч",
      "Вместительное основное отделение",
      "Система подвески с алюминиевым каркасом для лучшей воздухопроницаемости и снятия нагрузки с плеч",
      "Клапан с регулируемым по высоте положением",
      "Широкий и мягкий поясной ремень с карманом для мелочей или еды",
      "Регулируемая грудная стяжка со спасательным свистком",
      "Регулируемые плечевые лямки",
      "Отделение для питьевой системы",
      "Резинки для фиксации трубки питьевой системы",
      "Боковые карманы",
      "Боковые стяжки",
      "Пластиковые полукольца для крепления снаряжения спереди",
      "Крепления для треккинговых палок",
      "Карман спереди для дождевика или веревки",
      "Внутренний сетчатый карман",
      "В комплекте чехол от дождя (в отсеке на дне)",
    ],
  },

  {
    id: uuid(),
    title: "ФОНАРЬ НАЛОБНЫЙ",
    img: "lantern_blue.jpg",
    desc: "X-BALOG BL-539 ",
    category: "lantern",
    price: 16,
    column: [
      "Питание:3 шт ААА",
      "Габариты:55*45*43 ",
      "Направление и ремешок регулируются",
    ],
  },
  {
    id: uuid(),
    title: "ФОНАРЬ НАЛОБНЫЙ TREKKING ONNIGHT 100",
    img: "lantern_onnight.jpg",
    desc: "Дальность  освещения: 25м (80 люмен). 3 режима освещения: красный, эко-белый, яркий белый.",
    category: "lantern",
    price: 46,
    column: [
      "Питание:3 шт ААА(в наборе)",
      "Автономность: 30 ч в эко режиме.10 ч в интенсивном режиме",
      "Вес: 80г",
      "Защита от брызг и ударов",
    ],
  },
  {
    id: uuid(),
    title: "ФОНАРЬ НАЛОБНЫЙ 30 LUMEN ONNIGHT 50",
    img: "lantern_black.jpg",
    desc: "Дальность  освещения: 15м (30 люмен). 1 режима освещения.",
    category: "lantern",
    price: 35,
    column: [
      "Питание:2 шт ААА(в наборе)",
      "Автономность: 25 часов",
      "Вес: 65г",
      "Одна кнопка ON/OFF для удобства использования в перчатках или рукавицах",
      "Регулируемый ремешок",
      "Защита от брызг и ударов",
    ],
  },
  {
    id: uuid(),
    title: "USB-ФОНАРЬ НАЛОБНЫЙ FORCLAZ HL100",
    img: "lantern-usb.jpg",
    desc: "Дальность  освещения: 25м (120 люмен). 3 режима освещения: красный, эко-белый, яркий белый..",
    category: "lantern",
    price: 65,
    column: [
      "Питание: зарядка с помощью микро-USB",
      "Время зарядки: около 2,5 - 3 ч",
      "Автономность: 17 ч в эко режиме. 4 ч в интенсивном режиме",
      "Вес: 72г",
      "Регулируемый ремешок",
      "Защита от брызг и ударов",
    ],
  },
  {
    id: uuid(),
    title: "ФОНАРИК НАЛОБНЫЙ",
    img: "lantern_green.jpg",
    desc: "УЗ-918 ",
    category: "lantern",
    price: 24,
    column: [
      "2 режима работы",
      "Питание от встроенной батареи",
      "USB-кабель в комплекте",
      "Направление регулируется",
    ],
  },
  {
    id: uuid(),
    title: "ГАЗ ТУРИСТИЧЕСКИЙ",
    img: "gas450.jpg",
    desc: "Nurgaz 450GR ",
    category: "gas/burner",
    price: 52,
    column: [
      "Резьбовой",
      "Клапан мирового класс 7/16",
      "Двойная система уплотнений",
      "30% пропан/70% бутан",
      "Производство: Турция",
    ],
  },
  {
    id: uuid(),
    title: "ГАЗ ТУРИСТИЧЕСКИЙ",
    img: "gas230.jpg",
    desc: "Nurgaz 230GR ",
    category: "gas/burner",
    price: 36,
    column: [
      "Резьбовой",
      "Клапан мирового класс 7/16",
      "Двойная система уплотнений",
      "30% пропан/70% бутан",
      "Производство: Турция",
    ],
  },
  {
    id: uuid(),
    title: "ГАЗ ТУРИСТИЧЕСКИЙ",
    img: "gas80.jpg",
    desc: "Nurgaz 80GR ",
    category: "gas/burner",
    price: 28,
    column: [
      "Резьбовой",
      "Клапан мирового класс 7/16",
      "Двойная система уплотнений",
      "30% пропан/70% бутан",
      "Производство: Турция",
    ],
  },
  {
    id: uuid(),
    title: "КЕМПИНГОВЫЙ НАБОР ORCAMP K-192",
    img: "burnerGas.jpg",
    desc: "ГОРЕЛКА + БАЛЛОН 230 ГР",
    category: "gas/burner",
    price: 65,
    column: [
      "Максимально простая в использовании, удобная и очень экономная (мощность всего 0,8 кВт) -  газовая туристическая горелка",
      "Диаметр варочной поверхности горелки  125 мм создает достаточную поверхность для использования больших кастрюль и котелков",
      "Точная регулировка мощности пламени",
      "Картриджи резьбового стандарта соединения для этой горелки  можно купить практически в любой точке мира",
      "Вес: 190 г",
      "Размер: 125x75 мм",
      "Мощность: 0,8 кВт",
      "Расход газа: При использовании со средней мощностью 85 гр/час резьбовой балон объемом 230 грам  расходуеться за 4-5 часов",
      "Пьезоподжиг: нет",
      "30% пропан/70% бутан",
      "Производство: Турция",
    ],
  },
  {
    id: uuid(),
    title: "ГОРЕЛКА ТУРИСТИЧЕСКАЯ",
    img: "burner32.jpg",
    desc: "Nurgaz TS-5310 ",
    category: "gas/burner",
    price: 32,
    column: [
      "Мощная нержавеющая горелка",
      "Клапан мирового класс 7/16",
      "Долговечный латунный кран",
      "Производство: Турция",
    ],
  },
  {
    id: uuid(),
    title: "ГОРЕЛКА ТУРИСТИЧЕСКАЯ",
    img: "Campsor_folding.jpg",
    desc: "Campsor (складная) ",
    category: "gas/burner",
    price: 49,
    column: ["Материал: Алюминий", "Вес: 150 гр", "Пьезоподжиг"],
  },
  {
    id: uuid(),
    title: "ГАЗОВАЯ ГОРЕЛКА - ПЛИТА",
    img: "burner44.jpg",
    desc: "ДЛЯ ЦАНГОВЫХ БАЛЛОНОВ",
    category: "gas/burner",
    price: 44,
    column: ["Материал: Алюминий", "Вес: 150 гр", "Пьезоподжиг"],
  },
  {
    id: uuid(),
    title: "КОВРИК ПЕНКА",
    img: "mat_with_case.jpg",
    desc: "173*61*1см ",
    category: "mat",
    price: 52,
    column: ["Нескользящий"],
  },
  {
    id: uuid(),
    title: "КОВРИК ДЛЯ ПОХОДОВ И СПОРТА",
    img: "mat40.jpg",
    desc: "173*61*1см ",
    category: "mat",
    price: 47,
    column: ["Нескользящий"],
  },
  {
    id: uuid(),
    title: "КОВРИК С АЛЮМИНИЕВОЙ ФОЛЬГОЙ FORA",
    img: "mat_aluminum_foil_FORA.jpg",
    desc: "180*60*0,6см ",
    category: "mat",
    price: 35,
    column: ["Однослойный"],
  },
  {
    id: uuid(),
    title: "МНОГОФУНКЦИОНАЛЬНЫЙ КОВРИК QUECHUA",
    img: "matQuechua.jpg",
    desc: "180*50*0,7см ",
    category: "mat",
    price: 41,
    column: [
      "Размеры: 180*50*0,7 см.",
      "Вес: 210 грамм",
      "Материал: 100% полиэтилен",
      "С алюминиевую пленкой, которая предотвращает истирание и улучшает теплопроводность",
      "Для удобства переноски оснащен эластичной лентой",
    ],
  },
  {
    id: uuid(),
    title: "САМОНАДУВАЮЩИЙСЯ КОВРИК ДЛЯ КЕМПИНГА QUECHUA BASIC",
    img: "matBasic.webp",
    desc: "180*60*3 см ",
    category: "mat",
    price: 135,
    column: [
      "Размеры: 185 x 60 x 3 см",
      "1-местный 60 см зеленый",
      "Вес: 1,3 кг.",
      "Надувается без насоса",
      "В комплекте транспортеровочный чехол",
      "Размеры чехла: 31*16*16 см",
      "Занимаемый объем: 8 л",
    ],
  },
  {
    id: uuid(),
    title: "CИДЕНЬЕ ТУРИСТИЧЕСКОЕ DECATHLON",
    img: "sitting_DECATHLON.png",
    desc: "Из пеноматериала с металлизированным слоем",
    category: "mat",
    price: 16,
    shortly:
      "Сиденье с металлическим каркасом из пеноматериала, подходящий для треккинга.",
    column: [
      "Вес: 60 г",
      "Размеры: 34*23,7*1,5 см",
      "Эластичная лента с клипсой обеспечивает комфортное использование",
    ],
  },
  {
    id: uuid(),
    title: "КОВРИК СКЛАДНОЙ",
    img: "mat_portable.jpg",
    desc: "180*55*1см ",
    category: "mat",
    price: 65,
    column: ["Вес:370г"],
  },
  {
    id: uuid(),
    title: "НАДУВНОЙ КОВРИК ДЛЯ ТРЕККИНГА",
    img: "matair.png",
    desc: " 180 × 52 × 1 CM (L) MT500 AIR ",
    category: "mat",
    price: 255,
    column: [
      "Вес: 510 г",
      "Объем: 1,7 литра",
      "ЧЕХОЛ ДЛЯ ТРАНСПОРТИРОВКИ",
      "Размеры: 180 x 52 x 5 см.",
      " Удобная толстая спальная поверхность.8 сегментов",
      "Накачивается без насоса",
      "Двойной антивозвратный клапан",
      "Вставки из силикона от скольжения",
      " Идеальный матрас для температуры > 8°C",
      "10 см х Ø 22 см",
    ],
  },
  {
    id: uuid(),
    title: "СКЛАДНАЯ СИДУШКА (ПЕНКА)",
    img: "folding_mat.jpg",
    desc: "29*9.5*4.5см, складывается в 4 раза ",
    category: "mat",
    price: 24,
    column: ["Вес:60г"],
  },
  {
    id: uuid(),
    title: "ТРЕКИНГОВЫЕ ПАЛКИ",
    img: "trekking_poles_DECATHLON.avif",
    desc: "Комплекст из 2шт, алюминиевые ",
    category: "trekking sticks",
    price: 80,
    shortly:
      "Простая система регулировки push-pin (с кнопками) 110/115/120/125/130 см.",
    column: [
      "3 телескопические части",
      "Размер яруса: 55 см",
      "Ширина в раскрытом виде: ~5см",
      "Алюминиевые стержни 6061-T6",
      "Диаметр стержня 20/18/16 мм",
      "Стальной наконечник",
      "Вес: 200 гр.",
    ],
  },
  {
    id: uuid(),
    title: "ТРЕКИНГОВЫЕ ПАЛКИ",
    img: "trekking_sticks_black.jpg",
    desc: "Комплекст из 2шт, алюминиевые c вольфрамовый наконечник ",
    category: "trekking sticks",
    price: 139,
    shortly:
      "Простая система регулировки push-pin(с кнопками) 110/115/120/125/130 см.",
    column: [
      "3 телескопические части",
      "Длинная 2D-рукоятка, покрытая пеноматериалом",
      "Размер яруса: 55 см",
      "Ширина в раскрытом виде: ~5см",
      "Алюминиевые стержни 6061-T6",
      "Диаметр стержня 20/18/16 мм",
      "Стальной наконечник",
      "Вес: 230 гр.",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛКИ ДЛЯ СКАНДИНАВСКОЙ ХОДЬБЫ",
    img: "nordic_walking_sticks.jpg",
    desc: "Комплекст из 2шт, дюралюминий",
    category: "trekking sticks",
    price: 110,
    shortly: "Телескопические в три сложения , на рост от 100 см до 220 см.",
    column: [
      "Минимальная длина палки: 63см",
      "Максимальная длина палки: 135см",
    ],
  },
  {
    id: uuid(),
    title: "НАБОР НАКОНЕЧНИКОВ ДЛЯ ТРЕККИНГОВЫХ ПАЛОК",
    img: "tip.jpg",
    desc: "FORCIAZ (KOMПЛЕКТ ИЗ 2 ШТ)",
    category: "trekking sticks",
    price: 18,
    column: [
      "Основной компонент - 95% резина синтетическая, 5% сталь",
      "Мягкие закругленные резиновые накладки: гасят шум и удары",
      "Долговечность: очень прочная, устойчивая к истиранию и перфорации резина",
      "Вес: 12 г каждый",
    ],
  },
  {
    id: uuid(),
    title: "КОЛЬЦА ДЛЯ ТРЕККИНГОВЫХ ПАЛОК",
    img: "tip2.jpg",
    desc: "FORCIAZ (KOMПЛЕКТ ИЗ 2 ШТ)",
    category: "trekking sticks",
    price: 18,
    column: [
      "Предназначены для мягких поверхностей (снег, песок)",
      "Мягкий пластик. Способность к деформации увеличивает долговечност",
      "Внешний диаметр 92 мм.",
      "Вес: 17 г каждый",
      "Основной компонент 100% этиленвинилацетат",
    ],
  },
  {
    id: uuid(),
    title: "ЧАЙНИК ПОХОДНЫЙ BTRACE 1,1Л",
    img: "teapot_BTRACE1.jpg",
    desc: "Алюминий анодированный",
    category: "dishes",
    price: 114,
    column: ["Вес (г): 215", "Объем (мл): 1100"],
  },
  {
    id: uuid(),
    title: "МНОГОФУНКЦИОНАЛЬНАЯ ВИЛКА-ЛОЖКА (8 В 1)",
    img: "fork-spoon.webp",
    desc: "Из нержавеющий стали (цена за 1 единицу)",
    category: "dishes",
    price: 27,
    column: [
      "Pазмер:	18*4 см",
      "Толщина:	1.5 мм",
      "Вес:	44 гр",
      "Функции: ложка, вилка, зубчатое лезвие, открывалка для бутылок, гарпун (веревка-отверстие), консервный нож, 5 гаечных ключей (м2, м3, м3.5, м4, м5), подвесные отверстия",
    ],
  },
  {
    id: uuid(),
    title: "КЕМПИНГОВЫЙ ОБЕДЕННЫЙ НАБОР QUECHUA ДЛЯ 2 ЧЕЛОВЕК",
    img: "setForCamping.jpg",
    desc: "1 кастрюля со склодной ручкой 2 глубокие тарелки 2 столовых набора",
    category: "dishes",
    price: 109,
    column: [
      "Объем: 1,6 л",
      "Вес:560 г",
      "Посуда подходит для всех видов огня (дрова, глаз, индукция)",
    ],
  },
  {
    id: uuid(),
    title: "ЧАЙНИК QUECHUA НА 1 Л",
    img: "teapotDecatlon.jpg",
    desc: "Из нержавеющей стали",
    category: "dishes",
    price: 94,
    column: [
      "Объем: 1 л",
      "Вес: 340 г.",
      "Предназначено для всех видов костров и особенно для костров на дровах",
    ],
  },
  {
    id: uuid(),
    title: "ПЛАСТИКОВАЯ ТАРЕЛКА QUECHUA НА 1 Л",
    img: "plasticPlate.webp",
    desc: "Для похода и пикника",
    category: "dishes",
    price: 13,
    column: [
      "Вес: 69 г.",
      "Размер: Ø 19 см x 3 см",
      "Рельефное дно не дает тарелке перегреваться",
      "Из ударопрочного и жаропрочного полипропилена (100°C)",
    ],
  },
  {
    id: uuid(),
    title: "НАБОР ПОХОДНЫЙ ПЛАСТИКОВЫЙ - НОЖ, ВИЛКА И ЛОЖКА QUECHUA",
    img: "PLASTICCAMPING.jpg",
    desc: "3 столовых предмета (нож, вилка, ложка), которые скреплены вместе",
    category: "dishes",
    price: 12.5,
    column: [
      "Вес: 21 г.",
      "Размер: 15,5 x 2 x 3 см",
      "Эти пластиковые (из полиамида) столовые приборы особенно пригодны при использовании с набором посуды с антипригарным покрытием, поскольку они его не повреждают",
    ],
  },
  {
    id: uuid(),
    title: "МИСКА (0,5 Л.) QUECHUA",
    img: "dish.jpg",
    desc: "Легкую и прочную миска",
    category: "dishes",
    price: 15,
    column: [
      "Вес: 71 г.",
      "16 см в диаметре x 4,5 см",
      "Отверстие сбоку тарелки для легкой переноски снаружи рюкзака с помощью карабина",
      "Структурированный материал дна тарелки, предотвращающий распространение тепла от горячих жидкостей для удобства захвата",
    ],
  },
  {
    id: uuid(),
    title: "СТОЛОВЫЙ ПРИБОР ПЛАСТИКОВЫЙ СКЛАДНОЙ",
    img: "forkspoon.jpg",
    desc: "Вилка/ложка",
    category: "dishes",
    price: 16.5,
    column: [
      "Вес: 11 г.",
      "Большая длина (18,5 см)",
      "Размеры в разложенном виде: 18,5 x 3,5 x 2 см",
      "Размеры в сложенном виде: 10 x 3,5 x 3 см",
      "Занимая мало места в рюкзаке (10 см в сложенном виде)",
      "Структурированный материал дна тарелки, предотвращающий распространение тепла от горячих жидкостей для удобства захвата",
    ],
  },
  {
    id: uuid(),
    title: "ЗАЖИМ ДЛЯ КАСТРЮЛИ И СКОВОРОДКИ И ПРОЧИХ ПРЕДМЕТОВ",
    img: "clip.jpg",
    desc: "ЧАПЕЛЬНИК",
    category: "dishes",
    price: 18,
    column: [
      "Легкий алюминиевый чапельник обезопасит приготовление пищи на газовой горелке или таганке",
      "Размер:  12,5*2,8*2,5 см",
      "Вес: 40 гр",
    ],
  },
  {
    id: uuid(),
    title: "ТЕРМОКРУЖКА ИЗ НЕРЖАВЕЮЩЕЙ СТАЛИ 0.38 Л ",
    img: "termose1.jpg",
    desc: "MH500 QUECHUA",
    category: "thermos",
    price: 55,
    column: [
      "Двойная стенка с воздушной прослойкой позволяет сохранять температуру напитка",
      "Размеры: Ø 8,5 см x 11,2 см (ширина с ручкой 11 см)",
      "Вес: 255 г",
    ],
  },
  {
    id: uuid(),
    title: "КЕМПИНГОВАЯ ЧАШКА ИЗ НЕРЖАВЕЮЩЕЙ СТАЛИ",
    img: "thermose2.jpg",
    desc: "QUECHUA",
    category: "thermos",
    price: 32,
    column: [
      "2 ручки. Мерные деления внутри",
      "Выполнена из сверхпрочной нержавеющей стали",
      "Размеры: Ø 9 см x 8 см Объем: 0,45 литра (макс.) / 0,4 литра (полезный объем)",
      "Вес: 120 г",
    ],
  },
  {
    id: uuid(),
    title: "СУБЛИМАЦИОННАЯ КРУЖКА С ВАШИМ ПРИНТОМ",
    img: "cup2.jpg",
    desc: "Возможно нанесение любого принта",
    category: "thermos",
    price: 44,
    column: [
      "металлическая",
      "С карабином",
      "Рекомендовано мыть вручную",
      "Стоимость указана за готовую кружку с напечатанным изображением",
      "Диаметр: 7.5 см ",
      "Высота 9 см",
      "Объем 300 мл",
    ],
  },
  {
    id: uuid(),
    title: "БУТЫЛКА 1,5 Л",
    img: "thermose6.jpg",
    desc: " QUECHUA MH100 ИЗ НЕРЖАВЕЮЩЕЙ СТАЛИ",
    category: "thermos",
    price: 69,
    column: [
      "Полностью нержавеющая фляга (корпус + крышка) с завинчивающейся крышкой и ручкой для переноски",
      "Размеры: диаметр 9 см × 28,3 см (с опущенной ручкой) / 31 см",
      "Вес: 297 г",
    ],
  },
  {
    id: uuid(),
    title: "БУТЫЛКА 1 Л",
    img: "thermose7.jpg",
    desc: "QUECHUA MH500 ИЗ АЛЮМИНИЯ",
    category: "thermos",
    price: 52,
    column: [
      "Изделие на 72% состоит из переработанного алюминия для снижения воздействия на окружающую среду",
      "Быстрое открывание одной рукой, запираемая крышка с ручкой и встроенным фильтром.",
      "Вес: 174 г (корпус 127 г / крышка 47 г)",
      "Широкое горлышко для легкости наполнения, ручка для переноски",
      "Перед первым использованием трижды тщательно промыть изделие проточной водой",
      "Размеры: Ø 8 см x 27,8 см",
    ],
  },
  {
    id: uuid(),
    title: "БУТЫЛКА TRIBAN 0.650 Л",
    img: "botle.jpg",
    desc: "Фляга для велосипеда",
    category: "thermos",
    price: 38,
    column: [
      "Мягкая насадка на мундштук для удобства питья",
      "Пластик без привкуса и запаха",
      "Объем: 650 мл.",
      "Широкая прозрачная полоса с мерной шкалой для точного дозирования",
      "Накручивающаяся крышка и мундштук для гарантии полной герметичности",
      "Подходит для всех типов флягодержателей",
      "Пластик не имеет ни вкуса, ни запаха",
    ],
  },
  {
    id: uuid(),
    title: "БУТЫЛКА ПЛАСТИКОВАЯ 0,8 Л",
    img: "botle2.jpg",
    desc: "QUECHUA",
    category: "thermos",
    price: 28,
    column: [
      "Быстродействующий затвор можно открыть всего одним поворотом",
      "Прозрачный и безвкусный пластик",
      "Объем: 800 мл.",
      "Вес: 103 г ",
      "Большое горлышко, широкая ручка для удобной транспортировки",
      "Бутылка 100% полиэтилентерефталат (ПЭТФ) Крышка 100% полипропилен (ПП)",
    ],
  },
  {
    id: uuid(),
    title: "ТЕРМОС ИЗ НЕРЖАВЕЮЩЕЙ СТАЛИ - 1 ЛИТР",
    img: "thermose9.jpg",
    desc: "серый Quechua",
    category: "thermos",
    price: 118,
    column: [
      "Двойные стенки из нерж. стали 18/8 (304), воздушная прослойка между стенками",
      "Легкость ухода благодаря крышке с резьбой. Внутренняя стенка из нерж. стали",
      "Начал. темп. 95°С: 82°C после 6 ч., 73°C после 12 ч., 60°C после 24 ч",
      "Размеры: Ø 9 см x 30 см",
      "Вес: 630 г",
    ],
  },

  {
    id: uuid(),
    title: "TEPMOC - 0,4 Л",
    img: "thermose12.jpg",
    desc: "QUECHUA ИЗ НЕРЖАВЕЮЩЕЙ СТАЛИ",
    category: "thermos",
    price: 66,
    column: [
      "Двойные стенки из нерж. стали 18/8 (304), воздушная прослойка между стенками",
      "Легкость ухода благодаря крышке с резьбой. Внутренняя стенка из нерж. стали",
      "Начал. темп. 95°С: 76°C через 6 ч., 63°C через 12 ч., 48°C через 24 ч",
      "Размер: Ø 7 см x 22,4 см",
      "Вес: 290 г",
    ],
  },
  {
    id: uuid(),
    title: "TEPMOC - 0,5 Л",
    img: "thermose14.jpg",
    desc: "XINDA ИЗ НЕРЖАВЕЮЩЕЙ СТАЛИ",
    category: "thermos",
    price: 43,
    column: [
      "Теплоизоляционная способность 12-24 часов",
      "Оснащен замком безопасности, двойное страхование",
    ],
  },
  {
    id: uuid(),
    title: "TEPMOC - 1 Л",
    img: "thermose13.jpg",
    desc: "QUECHUA ИЗ НЕРЖАВЕЮЩЕЙ СТАЛИ",
    category: "thermos",
    price: 124,
    column: [
      "Чем более заполнен термос, тем лучше он держит температуру",
      "Легкость ухода благодаря крышке с резьбой. Внутренняя стенка из нерж. стали",
      "Крышка содержит встроенный фильтр, который фильтрует такие продукты, как фруктовые настойки или крупный чайный лист. Не подходит для очень мелкого чайного листа.",
      "Начал. темп. 95°С: остывает до 78°C за 6 ч",
      "Размеры: Ø 8,6 см x 30 см",
      "Вес: 405 г",
    ],
  },
  {
    id: uuid(),
    title: "ТЕРМОС - 0,8 Л",
    img: "thermose10.jpg",
    desc: "QUECHUA ИЗ НЕРЖАВЕЮЩЕЙ СТАЛИ MH500",
    category: "thermos",
    price: 112,
    column: [
      "Начал. темп. 95°С: остывает до 74°C за 6 ч.",
      "Быстрое открывание одной рукой, запираемая крышка с ручкой.",
      "Чем более заполнен термос, тем лучше он держит температуру",
      "Размер: Ø 8,2 см x 26,5 см",
      "Вес: 366 г  (корпус 320 г и крышка 46 г)",
      "Перед первым использованием трижды тщательно промыть изделие проточной водой",
      "Крышка содержит встроенный фильтр, который фильтрует такие продукты, как фруктовые настойки или крупный чайный лист. Не подходит для очень мелкого чайного листа.",
    ],
  },
  {
    id: uuid(),
    title: "TEPMOC STANLEY CLASSIC - 1 Л",
    img: "TEPMOCSTANIEY.jpg",
    desc: "Vacuum Bottle",
    category: "thermos",
    price: 203,
    column: [
      "Имеет прочный двухслойный корпус, вакуумную термоизоляцию, устойчив к ударам и падениям",
      "Оснащен складной ручкой, поэтому термос удобно держать в одной руке, а также наливать напитки",
      "При изготовлении термоса используется высококачественная пищевая нержавеющая сталь, благодаря чему он не ржавеет, не окисляется, не влияет на вкусовые качества напитков",
      "Сохраняет тепло до 28 часов, холод - до 34 часов",
      "Крышка емкостью 325 мл используется как чашка для питья, что удобно в путешествии, для выезда на природу, охоту или рыбалку",
      "Материал: нержавеющая сталь 18/8",
      "Вес: 810 г",
      "Объем: 1000 мл",
      "Объем крышки: 325 мл",
      "Размеры: 117 х 94 х 358 мм",
    ],
  },
  {
    id: uuid(),
    title: "ПОХОДНЫЙ ТЕРМОС ИЗ НЕРЖАВЕЮЩЕЙ СТАЛИ",
    img: "thermose3.jpg",
    desc: "1.5 л серо-черный QUECHUA",
    category: "thermos",
    price: 135,
    column: [
      "Два раскрытия: широкое/для розлива",
      "Ручка, кружка в комплекте",
      "Начальная температура 95°С:83°C через 6 ч, 74°С через 12 ч, 60°С через 24 ч.",
      "Складная ручка для транспортировки и легкости розлива",
      "Вымыть и высушить перед хранением. Хранить в чистом и сухом месте",
      "Размеры: Ø 12,5 см x 29 см",
      "Вес: 980 г.",
      "Наполните термос кипятком и оставьте на 5 минут.Затем замените воду нужным напитком. Закройте термос.Чем более заполнен термос, тем лучше он держит температуру",
      "Перед первым использованием тщательно трижды промойте все элементы изделия чистой водой",
    ],
  },
  {
    id: uuid(),
    title: "НОЖ-КАРАБИН",
    img: "knife1.jpg",
    desc: "VASTAR",
    category: "knife",
    price: 29,
    column: [
      "Вес: 40 г.",
      "Mатериал: нержавещая сталь",
      "Общая длина: 14 см",
      "Длина лезвия: 5.8 см",
      "Длина ручки: 8.2 cм",
    ],
  },
  {
    id: uuid(),
    title: "ПОХОДНЫЙ НОЖ (ХАКИ)",
    img: "knife2.jpg",
    desc: "QUECHUA MH100",
    category: "knife",
    price: 57,
    column: [
      "Вес: 75 г.",
      "Mатериал: нержавещая сталь",
      "Кнопка блокировки/разблокировки лезвия",
      "Размеры: 18,2 x 1,6 x 2,1 см",
      "Размеры в сложенном виде: 10,5 x 1,6 x 2,1 см",
      "Длина лезвия: 8 см",
    ],
  },
  {
    id: uuid(),
    title: "СКЛАДНОЙ ОХОТНИЧИЙ НОЖ",
    img: "knife3.jpg",
    desc: " SOLOGNAC AXIS 75 GRIP V2",
    category: "knife",
    price: 75,
    column: [
      "Вес: 100 г.",
      "Mатериал: нержавещая сталь",
      "Кнопка блокировки/разблокировки лезвия",
      "Фиксируется нож в кармане или на поясе с помощью металлической клипсы",
      "Общая длина в разложенном виде: 17 см",
      "Толщина лезвия: 2,5 мм",
      "Длина рукоятки: 9,7 см",
      "Длина лезвия: 7.5 см",
      "Угол 20°",
    ],
  },
  {
    id: uuid(),
    title: "СКЛАДНОЙ ОХОТНИЧИЙ НОЖ",
    img: "knife4.jpg",
    desc: " SOLOGNAC AXIS 85 GRIP V2",
    category: "knife",
    price: 89,
    column: [
      "Вес: 100 г.",
      "Mатериал: нержавещая сталь",
      "Кнопка блокировки/разблокировки лезвия",
      "Фиксируется нож в кармане или на поясе с помощью металлической клипсы",
      "Общая длина в разложенном виде: 20 см",
      "Толщина лезвия: 3 мм",
      "Длина рукоятки: 9,7 см",
      "Длина лезвия: 8.5 см",
      "Угол 20°",
    ],
  },
  {
    id: uuid(),
    title: "ШВЕЙЦАРСКИЙ АРМЕЙСКИЙ НОЖ",
    img: "knife5.jpg",
    desc: " VICTORINOX (АЛЬПИНИСТ) 14 ФУНКЦИЙ",
    category: "knife",
    price: 158,
    column: [
      "Многофункциональный складной нож, включающий в себя 14 инструментов",
      "Длина в сложенном виде: 111 мм",
      "Толщина лезвия: 2.5 мм",
      "Пластиковый кейс для ножей с замком система для безопасной транспортировки",
      "Лезвие: 100 % нержавеющая сталь",
      "Внешний корпус: 100 % акрилонитрилбутадиенстирол ",
      "Ручка: 100 % акрилонитрилбутадиенстирол (АБС)",
    ],
  },
  {
    id: uuid(),
    title: "СКЛАДНОЙ РЫБОЛОВНЫЙ НОЖ",
    img: "knife7.jpg",
    desc: "CAPERLAN KN FID",
    category: "knife",
    price: 49,
    column: [
      "Нержавеющая сталь с тефлоновым покрытием для защиты от ржавчиныв",
      "Устойчив к морской воде",
      "Его ручка плотно прилегает к вашей руке благодаря формованной эргономичной конструкции",
      "Общая длина: 19 см",
      "Длина лезвия:8,5 см",
      "Толщина лезвия: 3 мм",
      "Лезвие: 100 % нержавеющая сталь",
      "Рукоятка: 100 % полипропилен (ПП)",
      "Cмажьте лезвие силиконовым маслом и храните в сухом месте",
    ],
  },
  {
    id: uuid(),
    title: "ОХОТНИЧИЙ НОЖ",
    img: "knife6.jpg",
    desc: "SIKA 100 GRIP SOLOGNAC",
    category: "knife",
    price: 77,
    column: [
      "Длина лезвия: 10 см",
      "Общая длина: 22 см",
      "Ширина: 32 мм",
      "Угол 11°",
      "Лезвие дроп-наконечник (специально для охоты) имеет заточку скандинавского типа",
      "Ручка выполнена из 100% акрилонитрил-бутадиен-стирола",
      "Лезвие: 100 % нержавеющая сталь",
      "Наконечник занимает 3/4 длины всего лезвия",
    ],
  },
  {
    id: uuid(),
    title: "ДВУНАПРАВЛЕННЫЙ КАМЕНЬ (ТОЧИЛКА) ДЛЯ БЫСТРОЙ ЗАТОЧКИ SOlOGNAC",
    img: "sharpener.png",
    desc: "Брусок для быстрой заточки ножей двусторонний",
    category: "knife",
    price: 36,
    column: [
      "Для эффективной заточки: Проведите 5 раз лезвием в направлении от рукоятки к острию с 'карбидной' (металлической) стороны, затем 5 раз с 'керамической' (белой) стороны. Усилие должно быть сильным, но не чрезмерным. Повторяйте до достижения необходимого результата",
      "Угол 20°",
      "1 сторона из углерода",
      "1 сторона из керамики для точной заточки лезвия",
      "Ручка из синтетич. каучука для удобства захвата и АБС-пластик для прочности",
      "Длина: 8,5 см.",
      "Высота: 6,5 см.",
      "Вес: 60 г.",
    ],
  },
  {
    id: uuid(),
    title: "СКЛАДНОЙ СТУЛ QUECHUA",
    img: "chaiSmall.jpg",
    desc: "до 110 кг",
    category: "chair",
    price: 72,
    column: [
      "Вес:1кг",
      "Компактность в сложенном виде",
      "Вшитый ремень для транспортировки",
      "Простая система раскладывания. Резинка для фиксации в сложенном виде",
      "Максимальная нагрузка: 110 кг",
    ],
  },
  {
    id: uuid(),
    title: "СКЛАДНОЙ СТУЛ С ПОДСТАКАННИКОМ QUECHUA",
    img: "chairBig.jpg",
    desc: "до 110 кг",
    category: "chair",
    price: 169,
    column: [
      "Вес:1кг",
      "2 подлокотника | 1 подстаканник | Высота сиденья: 41 см",
      "Компактность в сложенном виде",
      "Размеры: 77,5 x 20 x 17 см",
      "Общий вес: 2,8 кг",
      "Встроенный ремень для легкости транспортировки и переноски",
      "Превосходная прочность конструкции и ткани",
      "Максимальная нагрузка: 110 кг",
    ],
  },
  {
    id: uuid(),
    title: "СКЛАДНОЙ СТУЛ С ПОДСТАКАННИКОМ ",
    img: "chair.jpg",
    desc: "до 110 кг",
    category: "chair",
    price: 89,
    column: [
      "Вес:1кг",
      "2 подлокотника | 1 подстаканник | Высота сиденья: 40 см",
      "Компактность в сложенном виде",
      "Общий вес: 2,3 кг",
      "В комплекте чехол для переноски",
      "Максимальная нагрузка: 110 кг",
    ],
  },
  {
    id: uuid(),
    title: "БАФФ",
    img: "buff.jpg",
    desc: "VAN RESELL",
    category: "buff",
    price: 36,
    column: [
      "Матовый флисовый компонент с внутренней стороны - сохраняет тепло, а снаружи - очень тонкий полиэстер, отводящий пот",
      "Его можно носить в разных вариантах, использовать в разных погодных условиях",
      "Стирать в стиральной машине при температуре 30°C (используйте синтетическую программу)",
    ],
  },
  {
    id: uuid(),
    title: "БАЛАКЛАВА (ВЕЛОСИПЕДНАЯ) БЕЗШОВНАЯ",
    img: "buff2.jpg",
    desc: "VAN RESELL 500",
    category: "buff",
    price: 39,
    column: [
      "Очень тонкий эластичный материал идеально адаптируется к любой форме лица",
      "Материал, гарантирующий защиту лица от холода",
      "Волокна материала отводят пот и препятствуют конденсации внутри",
      "Состав: 2.0% Эластан, 23.0% Полиамид, 75.0% Полиэтилентерефталат",
      "Стирка в прохладной воде (30° C) Программа стирки: 'синтетика'",
    ],
  },
  {
    id: uuid(),
    title: "ДЕТСКАЯ БАЛАКЛАВА",
    img: "buffForChild.jpg",
    desc: "(ЛЫЖНАЯ МАСКА) WEDZE",
    category: "buff",
    price: 29,
    column: [
      "продукт из 100% переработанного полиэстера",
      "Защищает голову, шею и челюсть от холода, сохраняя тепло",
      "Помимо базовых преимуществ, эта снежная маска под шлемом гарантирует гигиену головы, особенно в заемных и арендованных шлемах",
      "Подходит для диаметра 48-56 см.",
    ],
  },
  {
    id: uuid(),
    title: "БАФФ ",
    img: "buff3.jpg",
    desc: "VAN RYSEI ROADR 100",
    category: "buff",
    price: 30,
    column: [
      "Защиты от неблагоприятных условий (ветра, пыли) при велопоездке. Подходит также и для других видов спорта, например, для бега",
      "Быстросохнущий материал, обеспечивающий отвод пота",
      "Эластичность ткани позволяет носить ее как повязку на голове и шее",
      "Легкая и комфортная, не затрудняет дыхание",
      "100% переработаный полиэстер",
      "Стирка в прохладной воде (30° C)",
    ],
  },
  {
    id: uuid(),
    title: "ДОЖДЕВИК EVA RAINCOAT",
    img: "raincoat.jpg",
    desc: "С капюшоном 150см",
    category: "raincoat",
    price: 19,
    column: [
      "Имеет универсальный размер",
      "Быстро сохнет",
      "Стопроцентная водонепроницаемость, полностью защищает от дождя",
    ],
  },
  {
    id: uuid(),
    title: "ПОНЧО SOLOGNAC",
    img: "ponchoGreen.jpg",
    desc: "165-195 CM",
    category: "raincoat",
    price: 79,
    column: [
      "Вес пончо составляет 280 грамм",
      "Водонепроницаемость составляет 1000 мм водяного столба ",
      "Размеры пончо в сложенном виде составляют 23,5 см x 20 см",
      "Основная ткань выполнена из 100% полиэтилентерефталата, а покрытие - из 100% полиуретана",
      "Хранить только после полного высушивания",
    ],
  },
  {
    id: uuid(),
    title: "ПЛАЩ-ДОЖДЕВИК CAPERIAN",
    img: "rainCoverCaperlan.jpg",
    desc: "Размер 1 подойдет на рост 150 - 173 см. Размер 2 подойдет на рост 173 - 190 см.",
    category: "raincoat",
    price: 29,
    column: [
      "Состав: Материал ЭВА (этиленвинилацетат)",
      "Складывается в собственный карман для удобства переноски",
      "Стопроцентная водонепроницаемость, полностью защищает от дождя",
      "Хранить только после полного высушивания",
    ],
  },
  {
    id: uuid(),
    title: "ЧЕХОЛ ОТ ДОЖДЯ ДЛЯ РЮКЗАКА 40-60 Л",
    img: "backpackcase.jpg",
    desc: "Крепится с помощью простой резинки, охватывающей Ваш рюкзак",
    category: "raincoat",
    price: 32,
    column: [
      "Вес: 71 г.",
      "Водонепроницаемые чехлы из полиэстера и непромокаемые швы",
      "Предназначен для рюкзаков объемом от 40 до 60 литров",
    ],
  },
  {
    id: uuid(),
    title: "ЧЕХОЛ ОТ ДОЖДЯ ДЛЯ РЮКЗАКА 70-100 Л",
    img: "backpackcase70-100.jpg",
    desc: "Крепится с помощью простой резинки, охватывающей Ваш рюкзак",
    category: "raincoat",
    price: 36,
    column: [
      "Вес: 71 г.",
      "Водонепроницаемые чехлы из полиэстера и непромокаемые швы",
      "Предназначен для рюкзаков объемом от 70 до 100 литров",
    ],
  },
  {
    id: uuid(),
    title: "СОЛНЦЕЗАЩИТНЫЕ ОЧКИ",
    img: "sunglasses.jpg",
    desc: "3-Й КАТЕГОРИИ QUECHUA MH940",
    category: "sunglasses",
    price: 91,
    column: [
      "Особая форма: защищает глаза от ветра, брызг, плохой погоды",
      "Линзы категории 3 – фильтруют 100% УФ-лучей: идеальный выбор для солнечной погоды",
      "Резиновые наконечники дужек: препятствуют соскальзыванию очков",
      "Линзы из высокопрочного поликарбонатного пластика",
      "Вес: 26 г.",
      "100.0% Поликарбонат",
    ],
  },
  {
    id: uuid(),
    title: "СОЛНЦЕЗАЩИТНЫЕ ОЧКИ",
    img: "sunglasses2.jpg",
    desc: "3-Й КАТЕГОРИИ QUECHUA MH530",
    category: "sunglasses",
    price: 109,
    column: [
      "Особая форма: защищает глаза от ветра, брызг, плохой погоды",
      "Линзы категории 3 – фильтруют 100% УФ-лучей: идеальный выбор для солнечной погоды",
      "Резиновые наконечники дужек: препятствуют соскальзыванию очков",
      "Линзы из высокопрочного поликарбонатного пластика",
      "Вес: 26 г.",
      "100.0% Поликарбонат",
    ],
  },
  {
    id: uuid(),
    title: "СОЛНЦЕЗАЩИТНЫЕ ОЧКИ",
    img: "sunglasses3.jpg",
    desc: "3-Й КАТЕГОРИИ QUECHUA MH500",
    category: "sunglasses",
    price: 72,
    column: [
      "Особая форма: защищает глаза от ветра, брызг, плохой погоды",
      "Линзы категории 3 – фильтруют 100% УФ-лучей: идеальный выбор для солнечной погоды",
      "Резиновые наконечники дужек: препятствуют соскальзыванию очков",
      "Большие линзы для лучшего периферического обзора",
      "Линзы из высокопрочного поликарбонатного пластика",
      "Вес: 29 г.",
      "100.0% Поликарбонат",
    ],
  },
  {
    id: uuid(),
    title: "СОЛНЦЕЗАЩИТНЫЕ ОЧКИ",
    img: "sunglasses4.jpg",
    desc: "3-Й КАТЕГОРИИ KALENJI RUNSTYLE 2",
    category: "sunglasses",
    price: 88,
    column: [
      "Особая форма: защищает глаза от ветра, брызг, плохой погоды",
      "Линзы категории 3 – фильтруют 100% УФ-лучей: идеальный выбор для солнечной погоды",
      "Резиновые наконечники дужек: препятствуют соскальзыванию очков",
      "Большие линзы для лучшего периферического обзора",
      "Линзы из высокопрочного поликарбонатного пластика",
      "Вес: 24 г.",
      "100.0% Поликарбонат",
    ],
  },
  {
    id: uuid(),
    title: "СОЛНЦЕЗАЩИТНЫЕ ОЧКИ",
    img: "sunglasses5.jpg",
    desc: "3-Й КАТЕГОРИИ ROCKRIDER ST100",
    category: "sunglasses",
    price: 84,
    column: [
      "Особая форма: защищает глаза от ветра, брызг, плохой погоды",
      "Линзы категории 3 – фильтруют 100% УФ-лучей: идеальный выбор для солнечной погоды",
      "Резиновые наконечники дужек: препятствуют соскальзыванию очков",
      "Большие линзы для лучшего периферического обзора",
      "Линзы из высокопрочного поликарбонатного пластика",
      "Вес: 24 г.",
      "100.0% Поликарбонат",
    ],
  },
  {
    id: uuid(),
    title: "ГЕРМОПАКЕТ BTRACE",
    img: "packageBTRACE.jpg",
    desc: "ПЛОСКИЙ ПВХ 20X13см",
    category: "accessories",
    price: 27,
    column: ["Материал: ПВХ"],
  },
  {
    id: uuid(),
    title: "ОГНИВО BTRACE Ø 8 ММ",
    img: "flintBTRACE8.png",
    desc: "10х2,4х1,7см",
    category: "accessories",
    price: 39,
    column: ["Материал: Редкоземельный металл", "Диаметр (мм): 8"],
  },
  {
    id: uuid(),
    title: "КОЛЫШКИ BTRACE АЛЮМИНИЙ (КОМПЛЕКТ 10 ШТ.)",
    img: "aluminum_pegs_btrace.png",
    desc: "2шт-12₾",
    category: "accessories",
    price: 57,
    column: ["Материал: Алюминий"],
  },
  {
    id: uuid(),
    title: "ПОДУШКА НАДУВНАЯ INTEX",
    img: "inflatable_pillow_INTEX.webp",
    desc: "43*28*9см",
    category: "accessories",
    price: 20,
    column: [
      "Страна производства: Китай",
      "Производитель: Intex",
      "Вес упаковки (кг): 0.164",
    ],
  },
  {
    id: uuid(),
    title: "ПОДУШКА-ПОДГОЛОВНИК INTEX",
    img: "pillow_headrest.webp",
    desc: "36*30*10см",
    category: "accessories",
    price: 22,
    shortly:
      "Надувная подушка для шеи. Хорошо подходит для комфортного отдыха при дальних поездках или перелетах",
    column: [
      "Страна производства: Китай",
      "Производитель: Intex",
      "Вес упаковки (кг): 0.106",
    ],
  },
  {
    id: uuid(),
    title: "СОЛНЦЕЗАЩИТНЫЕ ОЧКИ QUECHUA MH140",
    img: "sunglasses.jpg",
    desc: "Анти-УФ-линзы блокируют 100% вредных лучей",
    category: "accessories",
    price: 79,
    column: [
      "Вес: 26г",
      "Линзы категории 3",
      "Особая форма: защищает глаза от ветра, брызг, плохой погоды",
      "Резиновые наконечники дужек: препятствуют соскальзыванию очков",
    ],
  },
  {
    id: uuid(),
    title: "БИНОКЛЬ SOLOGNAC",
    img: "binoculars.jpg",
    desc: "8-кратное приближение",
    category: "accessories",
    price: 89,
    column: ["Вес: 202г", "Верхнее покрытие : 100% Силикон"],
  },
  {
    id: uuid(),
    title: "БИНОКЛЬ QUECHUA MH B560",
    img: "quechuabinoculars.jpg",
    desc: "12-кратное приближение",
    category: "accessories",
    price: 182,
    shortly:
      "Компактный и легкий бинокль с простой регулировкой. Идеален для обзора панорамы во время походов. Большие объективы (32 мм) и специальное покрытие оптики для обеспечения четкости изображения. Подходит для тех, кто носит очки, благодаря выдвижному глазку, который можно откинуть назад.",
    column: [
      "Вес: 333г",
      "Оправа : 100% Поликарбонат",
      "В комплекте шнурок на шею и футляр из полиэстера для защиты от ударов и пыли, а также для легкости переноски.",
    ],
  },
  {
    id: uuid(),
    title: "БИНОКЛЬ QUECHUA MH B540",
    img: "binokl3.jpg",
    desc: "10-кратное приближение",
    category: "accessories",
    price: 165,
    shortly:
      "Компактный и легкий бинокль с простой регулировкой. Идеален для обзора панорамы во время походов. Большие объективы (32 мм) и специальное покрытие оптики для обеспечения четкости изображения. Подходит для тех, кто носит очки, благодаря выдвижному глазку, который можно откинуть назад.",
    column: [
      "Вес: 332г",
      "Оправа : 100% Поликарбонат",
      "В комплекте шнурок на шею и футляр из полиэстера для защиты от ударов и пыли, а также для легкости переноски.",
    ],
  },
  {
    id: uuid(),
    title: "КОВРИК ГЕРМЕТИЧНЫЙ ДЛЯ ПАЛАТКИ И ТАМБУРА ДЛЯ КЕМПИНГА",
    img: "kovrik.jpg",
    desc: "2 x 2,5 метра",
    category: "accessories",
    price: 69,
    column: [
      "Вес:593г",
      "Тент легко использовать благодаря металлическим встроенным кольцам",
      "Устойчив к истиранию и перфорации",
      "Состав : 100% водонепроницаемый полиэтилен",
    ],
  },
  {
    id: uuid(),
    title: "СПАСАТЕЛЬНОЕ ОДЕЯЛО",
    img: "rescueBlanket.jpg",
    desc: "SIMOND",
    category: "accessories",
    price: 28,
    column: [
      "Eго гибкий материал предотвращает зацепы и разрывы защищает от холода",
      "Отражая тепло тела может быть использовано повторно",
      "Основная ткань 100% полиэтилентерефталат",
      "Размеры - 90 * 210 см",
      "Вес: 115г",
    ],
  },
  {
    id: uuid(),
    title: "ОДЕЯЛО ПЕРВОЙ ПОМОЩИ",
    img: "safeBlanket.jpg",
    desc: "FORCIAZ 100",
    category: "accessories",
    price: 22,
    column: [
      "Односпальное термоодеяло для одноразового использования, чтобы защитить Вас от холода или тепла, когда это необходимо.",
      "Предназначено для использования только один раз, занимая минимум места и веса в рюкзаке",
      "Золотистая сторона (сверху) удерживает тепло и защищает от холода: предотвращает риск переохлаждения, сохраняет температуру тела, защищает от ветра и влажности",
      "Серебристая сторона (сверху) защищает от перегрева: поддерживает прохладу (машины, палатки и т.д.)",
      "Размеры: 160 x 210 см.",
      "Толщина: 0,012 мм",
      "Не накрывать голову – есть риск удушения. Не использовать в бурю, вблизи раскаленных веществ или при пользовании электрическими медицинскими аппаратами (например, аппаратом DSA). Не разрезать и не прокалывать. Хранить в сухом месте.",
    ],
  },
  {
    id: uuid(),
    title: "УГЛОВЫЕ СТЕРЖНИ (КОЛЫШКИ)",
    img: "pegs.jpg",
    desc: "QUECHUA - 10 ШТ",
    category: "accessories",
    price: 37,
    column: [
      "v-образная форма",
      "Подходят для влажных и рыхлых грунтов",
      "Основной компонент - 100% сталь",
      "Длина 23 см",
      "Ширина : 20 мм",
      "Вec: 50г",
      "Подходит для всех типов палаток",
    ],
  },
  {
    id: uuid(),
    title: "ГАМАК 300 × 150 CM ",
    img: "hammock.jpg",
    desc: "QUECHUA BASIC",
    category: "accessories",
    price: 109,
    column: [
      "Вес: 540 г",
      "Размеры 300 x 150 см",
      "Не стирать | Если необходимо: почистить влажной губкой",
      "Основная ткань/сумка для переноски 100% полиэтилентерефталат",
      "Рекомендуемый максимальный вес: 110 кг",
      "Крепления в комплекте",
    ],
  },
  {
    id: uuid(),
    title: "ОТРАЖАЮЩИЙ АВАРИЙНЫЙ БРАСЛЕТ ИЗ ПАРАКОРДА",
    img: "paracordbig.jpg",
    desc: "Цвет: черный, красный, оранжевый, хакки, серый, синий",
    category: "accessories",
    price: 15,
    column: [
      "Браслет при необходимости можно распустить в крепкий шнур длина веревки около 3 метров",
      "Длина браслета 24,5 см",
      "Вес: 30 гр",
      "Браслет имеет встроенный свисток и светоотражающий элемент",
      "Подходит для повседневного использования",
    ],
  },
  {
    id: uuid(),
    title: "БРАСЛЕТ ДЛЯ ВЫЖИВАНИЯ ИЗ ПАРАКОРДА",
    img: "paracordsmall.jpg",
    desc: "Цвет: черный, серый, розовый, желто-черный, бело-синий",
    category: "accessories",
    price: 9,
    column: [
      "браслет при необходимости можно распустить в крепкий шнур длина веревки около 3 метров,",
      "Длина браслета 22 см",
      "Вес: 18 гр",
      "Подходит для повседневного использования",
    ],
  },
  {
    id: uuid(),
    title: "НАДУВНАЯ ПОДУШКА ДЛЯ КЕМПИНГА",
    img: "airbasic.jpg",
    desc: "QUECHUA AIR BASIC ",
    category: "accessories",
    price: 28,
    column: [
      "Размеры: 27×37×10 см",
      "Вес: 100 г",
      "Чтобы подушка быстрее сдулась, рекомендуем сжать клапан, чтобы знать блокировку и выпустить воздух",
    ],
  },
  {
    id: uuid(),
    title: "НАДУВНОЙ МАТРАС ДВУХМЕСТНЫЙ",
    img: "matQ.jpg",
    desc: "QUECHUA AIR BASIC",
    category: "accessories",
    price: 28,
    column: [
      "Вес: 4 кг",
      "Размеры: 190 x 140 x 16 см",
      "Габаритные размеры: 8,2 л",
      "Рекомендуемый максимальный вес: 220 кг.",
      "Ремонтный комплект",
      "Надувается насосом за 1 минуту 40 сек.",
      "Противовозвратный клапан",
      "Надувается с помощью всех наших насосов для кемпинга (ножных, ручных, электр.)",
      "Велюровый на ощупь",
      "Искусственный материал: 100.0% Поливинилхлорид",
      "Только ручная стирка",
      "Не использовать в воде",
    ],
  },
  {
    id: uuid(),
    title: "НОЖНОЙ НАСОС",
    img: "media.jpg",
    desc: "QUECHUA",
    category: "accessories",
    price: 45,
    column: [
      "2,5 л воздуха за одно нажатие",
      "Вес: 822 г",
      "Объем: 33 см",
      "Ширина: 24,5 см",
      "Высота: 9,1 см",
      "Рекомендуется хранить это изделие в сухом месте, беречь от слишком низких и слишком высоких температур",
    ],
  },
  {
    id: uuid(),
    title: "ВЕТРОЗАЩИТНЫЙ МЕХАНИЗМ",
    img: "save.jpg",
    desc: "(ЭКРАН) FORCIAZ",
    category: "accessories",
    price: 59,
    column: [
      "Экран для защиты огня газовой горелки от ветра во время стоянок",
      "Вес: 200 г.",
      "Размеры: 59 см х 22 см",
      "Размер в сложенном виде: 9 см x 22 см",
      "Высота заслонки 22 см, поэтому она не подходит для печей, присоединенных к газовому баллончику 450 г, поскольку он уже имеет высоту 15 см.",
      "Перед использованием определить направление ветра. Развернуть экран и установить два загнутых крючка под газовой емкостью горелки. Расположить экран так, чтобы он закрывал горелку от ветра со всех сторон, оставляя при этом достаточно пространства для расположения самой горелки и блюда на ней. Воткнуть в землю колышки, чтобы обеспечить оптимальную устойчивость изделия к ветру.",
    ],
  },
  {
    id: uuid(),
    title: "ЛЫЖНЫЕ ПЕРЧАТКИ (ВЕРХОНКИ)",
    img: "glove.jpg",
    desc: " WEDZE 500",
    category: "accessories",
    price: 65,
    column: [
      "Водонепроницаемая мембрана и внешний материал с водоотталкивающей пропиткой",
      "Синтепон 200 г/м² (тыльн. ст.), 80 г/м² (ладонь), подклад., искус. мех. Манжеты.",
      "Эластичный шнурок на запястье",
      "Широкая манжета, которую можно расположить над или под рукавом куртки",
      "Ладонь из полиуретана, укрепленный указательный палец",
      "Стирка в прохладной воде (30° C)",
      "14.1% Хлопок, 2.5% Вискоза, 83.4% Полиэтилентерефталат",
    ],
  },
];
